import nxModule from 'nxModule';

// based on: https://stackoverflow.com/questions/15242592/how-to-autocapitalize-the-first-character-in-an-input-field-in-angularjs
nxModule.directive('capitalizeInput', function ($parse) {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, modelCtrl) {
      let capitalize = function (inputValue) {
        if (!inputValue) return '';
        let capitalized = inputValue.charAt(0).toUpperCase() + inputValue.substring(1);
        if (capitalized !== inputValue) {
          modelCtrl.$setViewValue(capitalized);
          modelCtrl.$render();
        }
        return capitalized;
      };
      modelCtrl.$parsers.push(capitalize);
      capitalize($parse(attrs.ngModel)(scope)); // capitalize initial value
    }
  };
});
